import { Link } from "react-router-dom";
import { Banknote, FileStack, TrendingUp, Users } from "lucide-react";
import { formatDate, formatMoney } from "../../lib/format";

const SALDO_HINT = "Suma del saldo insoluto de los créditos en MXN según el último Excel. No incluye créditos capturados a mano sin datos de pagos.";

const Card = ({ testId, icon: Icon, value, label, sub, title, i, to }) => {
  const Box = to ? Link : "div";
  return (
  <Box to={to} data-testid={testId} title={title} style={{ animationDelay: `${i * 60}ms` }}
    className={`tr-card tr-fade-up flex min-w-0 items-center gap-4 p-4 sm:p-5 ${to ? "transition-[border-color,box-shadow] hover:border-[#9bb7e8] hover:shadow-md" : ""}`}>
    <span className="inline-flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#eef4ff] text-[#0f5ef7]">
      <Icon className="h-5 w-5" />
    </span>
    <div className="flex min-w-0 flex-col">
      <span className="truncate text-xl font-extrabold tracking-tight text-[#182235] sm:text-2xl" data-testid={`${testId}-value`}>{value}</span>
      <span className="text-xs font-semibold text-[#5b667a] sm:text-sm">{label}</span>
      {sub && <span className="text-[11px] text-[#5b667a]" data-testid={`${testId}-sub`}>{sub}</span>}
    </div>
  </Box>
  );
};

export const StatCounters = ({ stats }) => {
  const cut = stats?.saldo_cut_date ? formatDate(stats.saldo_cut_date) : null;
  const month = stats?.month_label || "";
  return (
    <section className="grid grid-cols-1 gap-3 sm:grid-cols-2 sm:gap-5 xl:grid-cols-[0.75fr_0.75fr_1.25fr_1.25fr]" data-testid="dashboard-counters">
      <Card i={0} testId="counter-clientes" icon={Users} label="Clientes" value={stats ? stats.clientes.toLocaleString("es-MX") : "…"} />
      <Card i={1} testId="counter-creditos" icon={FileStack} label="Créditos" value={stats ? stats.creditos.toLocaleString("es-MX") : "…"} />
      <Card i={2} to="/portfolio" testId="counter-saldo" icon={Banknote} label="Outstanding Balance MXN" title={SALDO_HINT}
        value={stats ? formatMoney(stats.saldo_mxn) : "…"}
        sub={cut ? (stats.saldo_mixed_cuts ? `al corte más reciente: ${cut}` : `al ${cut}`) : null} />
      <Card i={3} testId="counter-revenue" icon={TrendingUp} label="Month Revenue"
        title={`Suma de los intereses (sin IVA) de las mensualidades programadas en ${month}, según el calendario del último Excel. Es un monto proyectado, no cobrado.`}
        value={stats ? formatMoney(stats.month_revenue) : "…"} sub={month ? `Intereses proyectados · ${month}` : null} />
    </section>
  );
};
